//@ts-nocheck
import * as React from 'react';
import { connect } from 'react-redux';
import * as d3 from 'd3';
import * as topojson from 'topojson';
import { MapWrapperProps, MapWrapperState } from '../../interface/MapInterface';
import { schemePurples, schemeBlues } from "d3-scale-chromatic";
import MapTooltip from "./MapTooltip";
import Map from "./Map";
import MapLegend from './MapLegend';
import { RadioGroup, RadioButton } from 'react-radio-buttons';
import ZoomHelp from "../reports/SpendingReport/ZoomHelp";

import { getDetailedDistrictReportDisplayData, downloadDetailedDistrictReport, setSelectedDistrictId, getAllSpending } from './../../actions/DetailedDistrictReportActions';

const us: { arcs: any, objects: any } = require("./us.json");
const states: { arcs: any, objects: any } = require("./cb_2024_us_state_20m.json");
const counties: { arcs: any, objects: any } = require("./cb_2024_us_county.json");//cb_2018_us_county_20m
const districts: { arcs: any, objects: any } = require("./USA_CD119.json");

class MapContainer extends React.Component<MapWrapperProps, MapWrapperState> {
    state = {
        landBoundary: {
            type: "", geometry: {}, properties: {}
        },
        shapeData: { type: "", features: [] },
        hover: false,
        hoverFeature: null,
        tooltipData: [],
        tooltipPosition: { left: null, top: null },
        tablename: "all",
        zoomTransform: null
    };

    zoomed = (e) => {
        this.setState(() => ({ zoomTransform: e.transform }))
    }

    zoom = d3.zoom()
        .scaleExtent([1, 8])
        .on("zoom", this.zoomed);

    mapArea: SVGAElement;


    activePath = d3.select(null);


    colorScheme = this.props.isEmployee
        ? schemeBlues[8]
        : this.props.agg
            ? schemePurples[7].slice(2)
            : schemePurples[5];

    mapAreaWidth = this.props.state_fips == '02' ? 600 : (this.props.isDetailedDistrict) ? 680 : (this.props.isEmployee) ? 700 : (this.props.isZoomed) ? 900 : this.props.isInState ? (this.props.factSheet ? 450 : 400) : ((this.props.isCongress) ? 750 : 500);
    mapAreaHeight = this.props.state_fips == '02' ? 500 : (this.props.isDetailedDistrict) ? 450 : (this.props.isEmployee) ? 450 : (this.props.isZoomed) ? 500 : (this.props.factSheet ? 720 : 330);

    viewBox = this.props.state_fips == '02' ? "0 0 600 500" :
        this.props.isDetailedDistrict ? "0 0 600 500" :
            this.props.isZoomed ? "0 0 1100 500" :
                this.props.isEmployee ? "0 0 700 450" :
                    this.props.factSheet ? "0 0 595 615" : "0 0 500 400"

    legendBoxPadding = 5;
    legendCellHeight = this.props.isZoomed ? 20 : 10;
    legendLineHeight = this.props.isZoomed ? 20 : 15;

    mapAreaRef = node => {
        this.mapArea = node;
    }

    getSpending() {
        if (!this.props.isCongress) {
            return this.props.isInState
                ? this.props.mapData.filter(d => d.statecode == this.props.state_fips).filter(d => d.tablename == this.state.tablename)
                : this.props.mapData.filter(d => d.tablename == this.state.tablename);
        } else {
            return this.props.isInState
                ? this.props.mapData.filter(d => {
                    d.congress_id = "0".repeat(4 - d.congress_id.length) + d.congress_id;
                    return +d.congress_id.slice(0, 2) == this.props.state_fips;
                })
                    .filter(d => d.tablename == this.state.tablename)

                : this.props.mapData.filter(d => d.tablename == this.state.tablename);
        }

    }

    /*getGeoPath = (obj?: {}) => {
        let projection;
        if (this.props.isEmployee) {
            if (this.props.isInState) {
                projection = d3.geoMercator().fitExtent([[0, 10], [this.mapAreaWidth, this.mapAreaHeight]], obj)
            }
            else
                projection = d3.geoAlbersUsa().scale(900).translate([this.mapAreaWidth / 2, this.mapAreaHeight / 2]);
        } else {
            projection =
                this.props.state_fips == '02' ?
                    d3.geoTransverseMercator().rotate([135 + 50 / 60, -30 - 30 / 60]).fitExtent([[0, 10], [this.mapAreaWidth, this.mapAreaHeight]], obj)
                    :
                    this.props.isInState
                        //for counties in the state, use projection.fitSize() to set the projection's scale and translate to fit the specified GeoJSON object
                        ? d3.geoMercator().fitExtent([[0, 10], [this.mapAreaWidth, this.mapAreaHeight]], obj)
                        //mannually set up scale and translate for all counties otherwise the browser would crash
                        : d3.geoAlbersUsa().scale(this.props.isZoomed ? 1200 : 700).translate([this.mapAreaWidth / 2, this.mapAreaHeight / 2]);
        }
        return d3.geoPath().projection(projection);
    }*/

    getColorScale() {
        if (!this.props.isEmployee) {
            const spending = this.getSpending();
            const spendingUniqueArray = [
                ...new Set(spending.map(location => location[!this.props.isCongress ? "total" : "payment_amt"]))
            ];
            const spendingThresholds = [50000, 250000, 500000, 1000000];
            const congressThresholds = [250000, 1000000, 5000000, 10000000]

            if (this.props.agg) {
                if (this.props.isCongress) {
                    return d3.scaleThreshold().domain(congressThresholds).range(this.colorScheme);
                } else {
                    return d3.scaleThreshold().domain(spendingThresholds).range(this.colorScheme);
                }
            } else {
                return d3.scaleQuantile().domain(spendingUniqueArray).range(this.colorScheme);
            }
        } else {
            if (this.props.isInState)
                return d3.scaleQuantile().domain(this.otherStateEmployeeCounts()).range(this.colorScheme);
            else {
                return d3.scaleQuantile().domain(this.otherStateEmployeeCounts()).range(this.colorScheme);
            }
        }
    }

    handleMouseEnter = (match, feature) => (e) => {
        const containerRect = this.mapArea.getBoundingClientRect();
        const left = this.props.isCongress ? `${e.clientX - containerRect["x"] + 25}px` : `${e.clientX - containerRect["x"]}px`;

        const top = this.props.isCongress
            ? e.clientY % containerRect["y"]
            : `${e.clientY - containerRect["y"] > this.mapAreaHeight / 2 ? e.clientY - containerRect["y"] - 100 : e.clientY - containerRect["y"] + 50}px`;

        this.setState(() => ({
            hover: true,
            hoverFeature: feature,
            tooltipData: match,
            tooltipPosition: { left, top }
        }))
    }

    handleMouseLeave = () => {
        this.setState(() => ({ hover: false }))
    }

    handleChange = (tablename) => {
        this.setState(() => ({ tablename }))
    }

    setStuffOnDropdownChange = () => {
        if (this.props.selectedCongressId != undefined) {
            let congressId = this.props.selectedCongressId

            const feature = this.state.shapeData.features.find(x => x.properties.GEOID == congressId);
            const pathId = "#path-" + congressId;

            this.activePath.classed("active", false);
            this.activePath = d3.select(pathId).classed("active", true);
            const bounds = this.getGeoPath(this.state.shapeData).bounds(feature),
                dx = bounds[1][0] - bounds[0][0],
                dy = bounds[1][1] - bounds[0][1],
                x = (bounds[0][0] + bounds[1][0]) / 2,
                y = (bounds[0][1] + bounds[1][1]) / 2,
                scale = Math.max(1, Math.min(8, 0.9 / Math.max(dx / this.mapAreaWidth, dy / this.mapAreaHeight))),
                translate = [this.mapAreaWidth / 2 - scale * x, this.mapAreaHeight / 2 - scale * y];
            this.props.getDetailedDistrictReportDisplayData(this.props.UserState.report_display_id, congressId, this.props.UserState.report_vintage_one_district);
        }
    }

    handleClick = (feature) => (e) => {
        if (this.props.isCongress) {
            let congressId = feature.properties.STATEFP + feature.properties.CD119FP
            //let congressId = feature.properties.state + feature.properties.CD118

            // set selected congressional district id in state
            this.props.setSelectedDistrictId(congressId);

            // load Detailed District Report top bullet points when clicked
            this.props.getDetailedDistrictReportDisplayData(this.props.UserState.report_display_id, congressId, this.props.UserState.report_vintage_one_district);
        }

        if (this.props.isEmployee) {
            this.props.employeeMapClick({ statecode: +feature.properties.GEOID, name: feature.properties.NAME });
        }
        else {
            if (this.activePath.node() === e.target) return this.reset();
            this.activePath.classed("active", false);
            this.activePath = d3.select(e.target).classed("active", true);
            const bounds = this.getGeoPath(this.state.shapeData).bounds(feature),
                dx = bounds[1][0] - bounds[0][0],
                dy = bounds[1][1] - bounds[0][1],
                x = (bounds[0][0] + bounds[1][0]) / 2,
                y = (bounds[0][1] + bounds[1][1]) / 2,
                scale = Math.max(1, Math.min(8, 0.9 / Math.max(dx / this.mapAreaWidth, dy / this.mapAreaHeight))),
                translate = [this.mapAreaWidth / 2 - scale * x, this.mapAreaHeight / 2 - scale * y];

            if (!this.props.isCongress) {
                d3.select(this.mapArea).transition()
                    .duration(750)
                    .call(this.zoom.transform, d3.zoomIdentity.translate(translate[0], translate[1]).scale(scale))
            }
        }
    }

    reset = () => {
        this.activePath.classed("active", false);
        this.activePath = d3.select(null);

        d3.select(this.mapArea).transition()
            .duration(750)
            .call(this.zoom.transform, d3.zoomIdentity);
    }

    createBoundary = () => {
        if (!this.props.isInState) {
            return topojson.feature(us, us.objects.land);
        }

        const matchState = topojson.feature(states, {
            type: "GeometryCollection",
            geometries: states.objects.cb_2024_us_state_20m.geometries.filter(
                d => +d.properties.STATEFP == this.props.state_fips
            )
        });
        return matchState.features[0];
    }

    createShapeData = () => {
        if (this.props.isCongress) {
            return this.props.isInState
                ? topojson.feature(districts, {
                    type: "GeometryCollection",
                    geometries: districts.objects["us_congressional_districts_2024"].geometries.filter(
                        d => +d.properties.STATEFP == this.props.state_fips
                    )
                })
                : topojson.feature(districts, districts.objects["us_congressional_districts_2024"]);
        }

        // Counties/States logic for non-congress maps
        if (this.props.isInState) {
            // State view: always use counties
            return topojson.feature(counties, {
                type: "GeometryCollection",
                geometries: counties.objects.cb_2024_us_county_20m.geometries.filter(
                    d => +d.properties.STATEFP === this.props.state_fips
                )
            });
        } else {
            // National view: employees use states, others use counties
            return this.props.isEmployee
                ? topojson.feature(states, states.objects.cb_2024_us_state_20m)
                : topojson.feature(counties, counties.objects.cb_2024_us_county_20m);
        }
    }

    getGeoPath = (referenceObj?: {}) => {
        let projection;
        // Use shapeData as the consistent reference for fitting
        const fitToObj = referenceObj || this.state.shapeData;

        if (this.props.isEmployee) {
            if (this.props.isInState) {
                projection = d3.geoMercator().fitExtent([[0, 10], [this.mapAreaWidth, this.mapAreaHeight]], fitToObj)
            } else {
                projection = d3.geoAlbersUsa().scale(900).translate([this.mapAreaWidth / 2, this.mapAreaHeight / 2]);
            }
        } else {
            projection = this.props.state_fips == '02'
                ? d3.geoTransverseMercator().rotate([135 + 50 / 60, -30 - 30 / 60]).fitExtent([[0, 10], [this.mapAreaWidth, this.mapAreaHeight]], fitToObj)
                : this.props.isInState
                    ? d3.geoMercator().fitExtent([[0, 10], [this.mapAreaWidth, this.mapAreaHeight]], fitToObj)
                    : d3.geoAlbersUsa().scale(this.props.isZoomed ? 1200 : 700).translate([this.mapAreaWidth / 2, this.mapAreaHeight / 2]);
        }
        return d3.geoPath().projection(projection);
    }

    updateMapBoundary = () => {
        this.setState(() => ({
            shapeData: this.createShapeData(),
            landBoundary: this.createBoundary()
        }));
        d3.select(this.mapArea).call(this.zoom);
    }
    componentDidUpdate(prevProps) {
        if (this.props.isInState !== prevProps.isInState ||
            this.props.state_fips !== prevProps.state_fips) {
            this.updateMapBoundary();
        }
    }

    componentDidMount() {
        this.updateMapBoundary();
    }

    homeStateEmployeeCount = this.props.isEmployee && this.props.mapData.filter(state => state.fips == this.props.state_fips).map(state => state.count);
    
    otherStateEmployeeCounts = () => {
        //console.log(this.props.mapData)
        //console.log(this.props)
        return (this.props.isInState == true) ?
            this.props.mapData.filter(state => state.statecode == this.props.state_fips &&
                !state.fips.endsWith("00")).map(state => state.count).sort((a, b) => b - a).filter(num => num !== 0)
                :
            this.props.mapData.filter(state => state.fips != this.props.state_fips.toString()).map(state => state.count).sort((a, b) => b - a).filter(num => num !== 0);
    }
        

    render() {
        console.log('Available state objects:', Object.keys(states.objects));
        console.log(counties);
        if (this.props.isDetailedDistrict && this.props.isCongress) {
            this.setStuffOnDropdownChange();
        }

        let clipPathId = this.props.isInState ? 'county-state' : 'county-nation';
        let chartNo;
        if (this.props.isCongress) {
            chartNo = 5;
            if (this.props.isZoomed) {
                clipPathId = this.props.isInState ? 'zoomed-state' : 'zoomed-nation'
            } else {
                clipPathId = this.props.isInState ? "state" : 'nation';
            }
        } else {
            chartNo = 3;
        }

        //console.log('landBoundary:', this.state.landBoundary);
        //console.log('clipPathId:', clipPathId);

        // Check if we can generate the path
        //if (this.state.landBoundary && this.state.landBoundary.geometry) {
        //    const pathString = this.getGeoPath(this.state.landBoundary)(this.state.landBoundary.geometry);
        //    console.log('📍 Generated SVG path:', pathString ? 'SUCCESS' : 'FAILED');
        //    console.log('📍 Path string length:', pathString?.length);
        //} else {
        //    console.log('❌ landBoundary or geometry is missing');
        //}
        
        return (

            <div className={(this.props.isCongress && !this.props.factSheet) ? this.props.isDetailedDistrict ? '' : 'congress-mapcontainer center_this' : 'mapcontainer'}>
                {!this.props.isDetailedDistrict && this.props.isZoomed &&
                    <div className="mapFilter">
                        <RadioGroup value="All" name="type" onChange={this.handleChange} horizontal>
                            <RadioButton pointColor="indigo" iconSize={20} iconInnerSize={10} padding={5} value="all">All</RadioButton>
                            <RadioButton pointColor="indigo" iconSize={20} iconInnerSize={10} padding={5} value="vendor">Vendor</RadioButton>
                            <RadioButton pointColor="indigo" iconSize={20} iconInnerSize={10} padding={5} value="subaward">Subaward</RadioButton>
                        </RadioGroup>
                    </div>
                }

                {!this.props.isDetailedDistrict && this.props.isZoomed && <ZoomHelp className="zoomhelp zoomed" chart_no={chartNo} />}

                <div className={!this.props.factSheet && !this.props.isEmployee ? "mapContent" : this.props.isEmployee ? "employeeMapContent" : ""}>
                    <svg width={this.mapAreaWidth} height={this.mapAreaHeight} ref={this.mapAreaRef}
                        className={this.props.isCongress ? '' : ''}
                        viewBox={this.viewBox}
                        >
                        <rect
                            width={this.mapAreaWidth}
                            height={this.mapAreaHeight}
                            onClick={this.reset}
                            //only inline style works with download otherwise there would be a black rect behind the map
                            style={{ fill: 'none', pointerEvents: 'all' }} />
                        {
                            <defs>
                                <path
                                    id={clipPathId}
                                    d={this.getGeoPath(this.state.landBoundary)(this.state.landBoundary.geometry)}
                                />
                            </defs>

                        }
                        {
                            <clipPath id={`clip-${clipPathId}`}>
                                <use xlinkHref={`#${clipPathId}`} />
                            </clipPath>
                        }

                        {
                            <g
                                clipPath={`url(#clip-${clipPathId})`}
                                //panning and wheel zoom
                                transform={
                                    this.props.isEmployee ? `translate(0,0)` :
                                        this.props.factSheet ? `translate(0,-160)` :
                                            this.state.zoomTransform && `translate(${this.state.zoomTransform.x}, ${this.state.zoomTransform.y}) scale(${this.state.zoomTransform.k})`}

                            >
                                <Map
                                    stateFips={this.props.state_fips}
                                    isEmployee={this.props.isEmployee}
                                    isCongress={this.props.isCongress}
                                    tablename={this.state.tablename}
                                    mapAreaWidth={this.mapAreaWidth}
                                    mapAreaHeight={this.mapAreaHeight}
                                    data={(this.props.isEmployee) ? this.props.mapData : this.getSpending()}
                                    colorScale={this.getColorScale()}
                                    isZoomed={this.props.isZoomed}
                                    isInState={this.props.isInState}
                                    isHovered={this.state.hover}
                                    shapeData={this.state.shapeData}
                                    handleMouseEnter={this.handleMouseEnter}
                                    handleMouseLeave={this.handleMouseLeave}
                                    getGeoPath={this.getGeoPath}
                                    handleClick={this.handleClick}
                                    isDetailedDistrict={this.props.isDetailedDistrict}
                                />

                                {this.props.isInState && this.state.landBoundary && (
                                    <path
                                        d={this.getGeoPath(this.state.landBoundary)(this.state.landBoundary.geometry)}
                                        fill="none"
                                        stroke="#D3D3D3"
                                        strokeWidth="3"
                                        style={{ pointerEvents: 'none' }}
                                    />
                                )}
                            </g>
                        }
                    </svg>


                    {(this.state.hover) &&
                        <MapTooltip
                            USState={this.props.USState}
                            position={this.state.tooltipPosition}
                            data={this.state.tooltipData}
                            hoverFeature={this.state.hoverFeature}
                            tablename={this.state.tablename}
                            isCongress={this.props.isCongress}
                            isEmployee={this.props.isEmployee}
                            agg={this.props.agg}
                        />}

                    {(!this.props.mapHasNoLegend) &&
                        <MapLegend
                            factSheet={this.props.factSheet}
                            mapAreaWidth={this.mapAreaWidth}
                            mapAreaHeight={this.mapAreaHeight}
                            mapAreaPadding={20}
                            legendAreaWidth={this.props.isEmployee ? 200 : 300}
                            legendTitleHeight={15}
                            legendPadding={10}
                            legendBoxPadding={5}
                            legendCellHeight={this.props.isEmployee ? 18 : 10}
                            legendCellWidth={20}
                            legendBoxWidth={150}
                            legendLineHeight={this.props.isEmployee ? 20 : this.props.isZoomed ? 20 : 15}
                            legendBoxMargin={5}
                            legendBoxHeight={(this.colorScheme.length + 1) * this.legendLineHeight - this.legendCellHeight + 2 * this.legendBoxPadding}
                            colorScale={this.getColorScale()}
                            tablename={this.state.tablename}
                            colorScheme={this.colorScheme}
                            isInstate={this.props.isInState}
                            isEmployee={this.props.isEmployee}
                            homeStateEmployeeCount={this.homeStateEmployeeCount}
                            otherStateEmployeeCounts={this.otherStateEmployeeCounts()}
                            isCongress={this.props.isCongress}
                            isZoomed={this.props.isZoomed}
                            agg={this.props.agg}
                        />
                    }
                </div>
            </div>
        )
    }
}

const mapStateToProps = state => ({
    UserState: state.userProperties,
    selectedCongressId: state.detailedDistrictReportProperties.selectedCongressId
});

const mapDispatchToProps = dispatch => ({
    getAllSpending: (displayId, vintage) => dispatch(getAllSpending(displayId, vintage)),
    getDetailedDistrictReportDisplayData: (displayId, congressId, vintage) => dispatch(getDetailedDistrictReportDisplayData(displayId, congressId, vintage)),
    downloadDetailedDistrictReport: congressReportData => dispatch(downloadDetailedDistrictReport(congressReportData)),
    setSelectedDistrictId: congressId => dispatch(setSelectedDistrictId(congressId))
});

export default connect(mapStateToProps, mapDispatchToProps)(MapContainer);